// The Django admin sends signed-out visitors to /login?next=/django-admin/...
// so they sign in on the app's own page. `next` is only honoured when it is a
// path inside the admin - never an arbitrary address - so the login page can't
// be used to bounce people to another site.
export const adminNextFromSearch = (search) => {
  const next = new URLSearchParams(search).get("next");
  if (!next || !/^\/django-admin\//.test(next) || next.includes("\\") || next.includes("//")) {
    return null;
  }
  return next;
};
